<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />
        <bread-crumbs :items="items" />
        <tabs-comp :tabs="tabs" />
        <main class="m-3 mb-5" :dir="lang.dir">
            <h5>{{ lang.car_report }}</h5>
            <form autocomplete="off" @submit.prevent="getCurrentCards">
                <v-row>
                    <v-col cols="12" md="2"><label for="vehicle-history-start">{{lang.start_date}}</label><b-form-input id="vehicle-history-start" type="date" v-model="sdate" /></v-col>
                    <v-col cols="12" md="2"><label for="vehicle-history-end">{{lang.end_date}}</label><b-form-input id="vehicle-history-end" type="date" v-model="edate" /></v-col>
                    <v-col cols="12" md="2"><label for="vehicle-history-mobile">{{lang.mobile}}</label><b-form-input id="vehicle-history-mobile" v-model="mobile" /></v-col>
                    <v-col cols="12" md="4"><label>{{lang.plate_number}}</label><div class="d-flex" dir="ltr">
                        <b-form-input v-model="pl.c1" :aria-label="lang.car_history_plate_first" />
                        <b-form-input v-model="pl.c2" :aria-label="lang.car_history_plate_second" />
                        <b-form-input v-model="pl.c3" :aria-label="lang.car_history_plate_third" />
                        <b-form-input v-model="pl.text" :aria-label="lang.car_history_plate_digits" />
                    </div></v-col>
                    <v-col cols="12" md="2"><b-button type="submit" variant="primary" :disabled="loading">{{lang.search}}</b-button></v-col>
                </v-row>
            </form>
            <p>{{lang.car_history_filter_required}}</p>
            <p v-if="loading" role="status">{{lang.car_history_loading}}</p>
            <p v-if="errorMessage" role="alert" class="text-danger">{{errorMessage}}</p>
            <v-simple-table>
                <thead><tr><th>{{lang.invoiceno}}</th><th>{{lang.customer_type}}</th><th>{{lang.customer}}</th><th>{{lang.company_name}}</th><th>{{lang.mobile}}</th><th>{{lang.inv_date}}</th><th>{{lang.total}}</th><th>{{lang.vat}}</th><th>{{lang.ftotal}}</th><th>{{lang.paid}}</th><th>{{lang.remain}}</th><th>{{lang.action}}</th></tr></thead>
                <tbody>
                    <tr v-for="item in invoicesrows" :key="item.id">
                        <td>{{item.invoice_number}}</td><td>{{customerType(item.customer_type)}}</td><td>{{item.full_name}}</td><td>{{item.company_name || item.entity_name}}</td><td>{{item.mobile}}</td><td>{{String(item.inv_date || '').slice(0,10)}}</td>
                        <td>{{item.total}}</td><td>{{item.vat}}</td><td>{{item.ftotal}}</td><td>{{item.paid}}</td><td>{{item.remain}}</td>
                        <td><b-button type="button" size="sm" variant="primary" v-b-toggle.pview_invoice @click="getInvo(item)">{{lang.view}}</b-button></td>
                    </tr>
                    <tr v-if="searched && !loading && !invoicesrows.length && !errorMessage"><td colspan="12">{{lang.car_history_empty}}</td></tr>
                </tbody>
                <tfoot v-if="invoicesrows.length"><tr><th colspan="6">{{lang.total}} ({{invoicesrows.length}})</th><th>{{totals.total}}</th><th>{{totals.vat}}</th><th>{{totals.ftotal}}</th><th>{{totals.paid}}</th><th>{{totals.remain}}</th><th></th></tr></tfoot>
            </v-simple-table>
        </main>
        <Footer />
        <popViewInvocie ref="popviewinv" />
    </div>
</template>
<script>
import breadCrumbs from '@/components/breadCrumbs.vue'
import TabsComp from '@/components/tabsComp.vue'
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import PopViewInvocie from '@/components/popViewInvocie.vue'
import ExportsPrint from '@/components/exports-print.vue'
import axios from 'axios'
export default {
    components:{breadCrumbs,TabsComp,HeaderPortrate,Footer,PopViewInvocie,ExportsPrint},
    data(){
        const now=new Date();
        return {sdate:`${now.getFullYear()}-01-01`,edate:`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`,mobile:'',pl:{c1:'',c2:'',c3:'',text:''},invoicesrows:[],totals:{},loading:false,searched:false,errorMessage:'',requestVersion:0};
    },
    methods:{
        collectSearch(){return {module:'carReport',elements:{sdate:this.sdate,edate:this.edate,mobile:this.mobile.trim(),plate_number:this.plate_number,language:this.lang.langname}};},
        customerType(type){const labels=this.lang.langname==='en'?['-','Individual','Company','Government']:this.lang.langname==='ur'?['-','فرد','کمپنی','سرکاری ادارہ']:['-','فردي','شركة','جهة حكومية'];return labels[Number(type)]||'-';},
        getInvo(item){this.$refs.popviewinv.invid=item.id;this.$refs.popviewinv.showButtons=false;return this.$refs.popviewinv.getInvoice();},
        async getCurrentCards(){
            const version=++this.requestVersion;
            this.errorMessage='';this.invoicesrows=[];this.totals={};this.searched=true;
            const filters=this.collectSearch().elements;
            const validDate=value=>/^\d{4}-\d{2}-\d{2}$/.test(value)&&!Number.isNaN(Date.parse(value+'T00:00:00Z'))&&new Date(value+'T00:00:00Z').toISOString().slice(0,10)===value;
            if(!validDate(filters.sdate)||!validDate(filters.edate)||filters.sdate>filters.edate){this.errorMessage=this.lang.car_history_filter_invalid;this.loading=false;return false;}
            if(!filters.mobile&&!filters.plate_number){this.errorMessage=this.lang.car_history_filter_required;this.loading=false;return false;}
            const post=new FormData();post.append('type','getVehicleInvoiceHistory');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));post.append('financeYear',localStorage.getItem('financeYear'));
            for(const [key,value] of Object.entries(filters))post.append(`data[${key}]`,value);
            this.loading=true;
            try{
                const {data:res}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);
                if(version!==this.requestVersion)return false;
                if(Number(res?.error?.number)!==200||!Array.isArray(res?.results?.data))throw new Error('report_failed');
                this.invoicesrows=res.results.data;this.totals=res.results.totals||{};return true;
            }catch(error){if(version===this.requestVersion)this.errorMessage=this.lang.car_history_load_failed;return false;}
            finally{if(version===this.requestVersion)this.loading=false;}
        }
    },
    computed:{
        plate_number(){return [this.pl.c1,this.pl.c2,this.pl.c3,this.pl.text].map(value=>String(value||'').trim()).filter(Boolean).join(' ');},
        lang(){return this.$store.state.lang[this.$cookies.get(this.$store.state.LangCooki)||this.$store.state.deflang]||this.$store.state.lang.ar;},
        items(){return {text:this.lang.car_report,disabled:true,href:'/car-report'};},
        tabs: function() {
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
        }
    }
}
</script>
